import { Table, Group, Text } from "@mantine/core";
import { IconChevronUp, IconChevronDown } from "@tabler/icons-react";
import { useCallback, useMemo } from "react";

interface PortalSortHeaderProps {
  field: string;
  label: string;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  onSort?: (field: string) => void;
}

export function PortalSortHeader({
  field,
  label,
  sortField,
  sortOrder,
  onSort,
}: PortalSortHeaderProps) {
  const handleSortClick = useCallback(() => {
    if (onSort) {
      onSort(field);
    }
  }, [field, onSort]);

  const isSorted = useMemo(() => sortField === field, [sortField, field]);

  return (
    <Table.Th
      style={{ cursor: "pointer", userSelect: "none" }}
      onClick={handleSortClick}
    >
      <Group gap="xs" wrap="nowrap">
        <Text size="sm" fw={700}>
          {label}
        </Text>
        {isSorted &&
          (sortOrder === "asc" ? (
            <IconChevronUp size={14} />
          ) : (
            <IconChevronDown size={14} />
          ))}
      </Group>
    </Table.Th>
  );
}

export default PortalSortHeader;
